var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import { getChequeBlockRemaining, formatRemainingTime, } from '../../shared/chequeBlockStorage';
var ChequeBlockTimer = /** @class */ (function (_super) {
    __extends(ChequeBlockTimer, _super);
    function ChequeBlockTimer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            remaining: getChequeBlockRemaining(_this.props.gamblerId),
        };
        _this.hasExpired = false;
        _this.handleTick = function () {
            var remaining = getChequeBlockRemaining(_this.props.gamblerId);
            if (remaining <= 0) {
                if (!_this.hasExpired) {
                    _this.hasExpired = true;
                    _this.props.onExpire();
                }
                return;
            }
            _this.setState({ remaining: remaining });
        };
        return _this;
    }
    ChequeBlockTimer.prototype.componentDidMount = function () {
        this.intervalId = setInterval(this.handleTick, 1000);
        document.addEventListener('visibilitychange', this.handleTick);
        this.handleTick();
    };
    ChequeBlockTimer.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
        document.removeEventListener('visibilitychange', this.handleTick);
    };
    ChequeBlockTimer.prototype.render = function () {
        if (this.state.remaining <= 0) {
            return null;
        }
        return this.props.renderTime(formatRemainingTime(this.state.remaining));
    };
    return ChequeBlockTimer;
}(React.Component));
ChequeBlockTimer.propTypes = {
    gamblerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onExpire: PropTypes.func.isRequired,
    renderTime: PropTypes.func.isRequired,
};
export default ChequeBlockTimer;



// WEBPACK FOOTER //
// ./src/components/recharge/ChequeBlockTimer.jsx